import { faUndo } from "@fortawesome/pro-solid-svg-icons/faUndo";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconUndo: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faUndo} />;
};
